import styled from 'styled-components';

export const Container = styled.div`
  .video-react {
    padding-top: 400px !important;
  }

  .card-video {
    height: 400px;
  }

  .send-advertence {
    margin: 10px 0 0 auto;
  }
`;

export const ButtonPanel = styled.div`
  margin-bottom: 20px;
  display: flex;

  & > * {
    margin-right: 10px;
  }
`;

export const Table = styled.table`
  text-align: center;

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/PostDetail/styles.js